<template>
  <div
    class="mini-hub mini-whitepaper"
    :class="{ 'has-post-thumbnail': post.featured_image_url }"
    :style="bgImage"
  >
    <div class="inner">
      <etiquette v-bind:post-type="post.type" />

      <h3 class="title" v-html="title_linked"></h3>

      <tags :tagsArray="post.tags" />

      <Button :link="post.link" :postType="post.type" />
    </div>

    <div class="overlay" v-if="post.featured_image_url"></div>
  </div>
</template>

<script>
import Etiquette from "../parts/Etiquette";
import Button from "../parts/Button";
import Tags from "../parts/Tags";

export default {
  name: "Whitepaper",
  components: {
    Etiquette,
    Button,
    Tags,
  },
  props: {
    post: Object,
  },
  computed: {
    bgImage: function () {
      if (this.post.featured_image_url) {
        return {
          backgroundImage: "url(" + this.post.featured_image_url + ")",
        };
      }
      return {};
    },
    title_linked: function () {
      return (
        '<a href="' + this.post.link + '">' + this.post.title.rendered + "</a>"
      );
    },
  },
};
</script>
